import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { HEADER_PROPTYPES } from '../constants/header';

import ConnectedHeaderBackground from '../containers/ConnectedHeaderBackground';

import HeaderTitle from './HeaderTitle';
import ImageAttribution from './ImageAttribution';

import './Header.scss';

export default class Header extends Component {
    static propTypes = {
        isLoading: PropTypes.bool.isRequired,
        // eslint-disable-next-line
        history: PropTypes.object,
        header: PropTypes.shape(HEADER_PROPTYPES),
        clickCTASeasonal: PropTypes.func,
    };

    render() {
        const { header = {}, isLoading, clickCTASeasonal } = this.props;

        const feedHeaderClassNames = classNames(['feed-header']);

        let titleComponent = null;

        if (!isLoading) {
            titleComponent = (
                <HeaderTitle
                    header={header}
                    clickCTASeasonal={clickCTASeasonal}
                />
            );
        }

        return (
            <section className={feedHeaderClassNames}>
                <div className="feed-header__bg-box" />
                <ConnectedHeaderBackground
                    type="MainHeaderBackground"
                    isSeasonal={header.shouldShowCustomContent}
                />

                <div className="feed-header__content">
                    <div>{titleComponent}</div>

                    <ImageAttribution attribution={header.attribution} />
                </div>
            </section>
        );
    }
}
